import { createRoute } from '@tanstack/react-router';
import { authenticatedRoute } from './_authenticated';
import { AlbumDetailPage } from '@/pages/AlbumDetailPage';

export const albumDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: 'albums/$albumId',
  component: function AlbumDetailRouteComponent() {
    const { albumId } = albumDetailRoute.useParams();
    return <AlbumDetailPage albumId={albumId} />;
  },
});
